import React, { useEffect, useState, useMemo } from 'react'
import { IBaseDynamicFormElement } from '../Form/DynamicForm'
import { useDispatch } from 'react-redux'
import { useCreateBlockNote } from "@blocknote/react";
import { BlockNoteView } from "@blocknote/mantine";
import { Block, BlockNoteEditor, PartialBlock } from "@blocknote/core";
import { createReactBlockSpec, useEditorChange } from "@blocknote/react";
import api from '../../services/api';
import ApplicationConfig from '../../config';
import { useReturnCurrentUser } from '../../features/user/userSlice';

export default function BlockEditor(props: IBaseDynamicFormElement) {

    const dispatch = useDispatch()

    const { id, label, fullWidth, handleOnChange, data, multiline, maxRows, minRows, handleKeyUp, enableQrCodeScanner, validateInput, placeholder } = props
    const [initialContent, setInitialContent] = useState<
    PartialBlock[] | undefined | "loading"
  >("loading");

    const [isDataSet, setIsDataSet] = useState<boolean>(false)

    const [blocks, setBlocks] = useState<Block[]>([]);

    const currentUser = useReturnCurrentUser()

    /**
     * Upload image
     */
    async function uploadFile(file: File) {
        const body = new FormData();
        body.append("image", file);
       
        const response = await fetch(ApplicationConfig.apiBaseUrl + "/uploader/image", {
            method: "POST",
            body: body,
            credentials: "include"
        });

        if (!response.ok) {
            throw new Error(`Failed to upload image: ${response.statusText}`);
        }
    
        const data = await response.json();
        console.log("Uploaded image URL:", data.url);
        return data.url; // Ensure this is the correct field returned from your API
    }
    
    // const editor = useCreateBlockNote({
    //     initialContent: editorContent,
    //     uploadFile,
    // })

    // useEffect(() => {
    //     props.handleOnChange(id, blocks)
    // }, [blocks])

    useEffect(() => {
        if (data.value){
            if (!isDataSet){
                setInitialContent(data.value)
                setIsDataSet(true)
            }
        }else{
            setInitialContent([ {
                type: "paragraph",
                content: "Start typing",
            }])
            setIsDataSet(false)
        }
    }, [data.value])

    const editor = useMemo(() => {
        if (initialContent === "loading") {
          return undefined;
        }
        return BlockNoteEditor.create({ initialContent, uploadFile });
      }, [initialContent]);
     
      if (editor === undefined) {
        return "Loading content...";
      }


    return (
      <div className="block-note-editor-container">

            {label && (
                <div className="label-of-block-note-editor-container">
                    <div className="content-of-label-of-block-note-editor-container">
                        <p>{label}</p>
                    </div>
                </div>
            )}

            <div className="content-of-block-note-editor-container">
                {editor ? <BlockNoteView 
                                editor={editor} 
                                theme={currentUser.theme === "dark" ? "dark" : "light" }
                                // onSelectionChange={() => {
                                //     const selection = editor.getSelection();

                                //     if (selection !== undefined) {
                                //       setBlocks(selection.blocks);
                                //     } else {
                                //       setBlocks([editor.getTextCursorPosition().block]);
                                //     }
                                //   }}
                                onChange={() => {
                                    props.handleOnChange(id, editor.document)
                                }}
                        /> : <p>Loading editor...</p>}
            </div>
      </div>
    )
}